import { gql, useQuery } from 'urql'
import ServiceSliderSection, { ServiceSliderSectionProps } from './ServiceSliderSection'
import { GeneralServiceOrderByColumn, SortOrder } from 'gql/graphql'

interface MostPopularServicesSectionProps extends Pick<ServiceSliderSectionProps, 'className'> {}

const MostPopularServicesSection = (props: MostPopularServicesSectionProps) => {
  const [{ data, fetching }] = useQuery({
    query: gql`
      query MostPopularServices(
        $orderBy: [GeneralServiceOrderByClause!]
      ) {
        services(first: 9, orderBy: $orderBy) {
          data {
            id
            title
            slug
            survey_slug
            description
            service_image {
              id
              url
            }
            image_alt_text
            form_link
          }
        }
      }
    `,
    variables: {
      orderBy: [{
        column: GeneralServiceOrderByColumn.Popularity,
        order: SortOrder.Desc,
      }],
    },
  })

  return (
    <ServiceSliderSection
      className={{
        container: props.className?.container
          ? props.className?.container
          : 'my-75 lg:my-[175px]',
        ...props.className,
      }}
      fetching={fetching}
      subheading="Most Popular"
      heading="Browse the most popular services and experiences"
      description="Get inspired and view the most popular holiday additions among our guests. Upon booking, our in-house concierge team can assist you in tailoring your stay to create an unforgettable holiday based on your tastes and preferences."
      data={data}
      button={{
        href: '/services/all?filter=Experiences',
        text: 'View Experiences',
      }}
    />
  )
}


export default MostPopularServicesSection
